import { createStyles, Grid, makeStyles } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            flex: 1,
            margin: 'auto',
            maxWidth: 'unset',
            // [theme.breakpoints.down('xs')]: {
            //     maxWidth: 'unset',
            // },
            // [theme.breakpoints.down('sm')]: {
            //     maxWidth: 'unset',
            // },
            // [theme.breakpoints.down('md')]: {
            //     maxWidth: 'unset',
            // },
            [theme.breakpoints.down('lg')]: {
                maxWidth: 1440,
            },
            [theme.breakpoints.down('xl')]: {
                maxWidth: 1440,
            },
        },
    })
);

export default function PageContainer({ children }) {
    const classes = useStyles();

    return (
        <Grid className={classes.root} container direction="column">
            {children}
        </Grid>
    )
}
